/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import { Container } from '@material-ui/core';

const styles = () => ({
    root: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.40)',
        zIndex: 1, // TODO: if we overlapping and the API get stuck user get block
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    contLoader: {
        display: 'flex',
        justifyContent: 'center',
        margin: '40px auto',
    },
    bouncingDot: {
        width: '5px',
        height: '5px',
        margin: '3px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        opacity: 1,
        animation: '$componentLoader 0.6s infinite alternate',
    },
    '@keyframes componentLoader': {
        to: {
            opacity: 0.1,
            transform: 'translateY(-6px)',
        },
    },
    bouncingDot1: {
        animationDelay: '0.2s',
    },
    bouncingDot2: {
        animationDelay: '0.4s',
    },
    bouncingDot3: {
        animationDelay: '0.6s',
    },

});

const LocalFeatureLoader = ({ classes }) => (
    <Container className={classes.root}>
        <div className={classes.container}>
            <div className={classes.contLoader}>
                <div className={`${classes.bouncingDot} ${classes.bouncingDot1}`} />
                <div className={`${classes.bouncingDot} ${classes.bouncingDot2}`} />
                <div className={`${classes.bouncingDot} ${classes.bouncingDot3}`} />
            </div>
        </div>
    </Container>

);

LocalFeatureLoader.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(LocalFeatureLoader);
